import { useState } from "react";
import styles from "./TraderMenuPanel.module.css";
import { FaLayerGroup, FaAngleDown, FaAngleRight } from "react-icons/fa";
import useDashboardStore from "../../store/dashboardStore";

const TraderMenuPanel = () => {
  const [openLiveSessions, setOpenLiveSessions] = useState(true);
  const {
    setIsCreateLiveSessionScreen,
    setIsAllLiveSessionScreen,
    isAllLiveSessionScreen,
    isCreateLiveSessionScreen,
  } = useDashboardStore();

  return (
    <div className={styles.panelWrapper}>
      <div
        className={styles.menuItem}
        onClick={() => setOpenLiveSessions(!openLiveSessions)}
      >
        <FaLayerGroup className={styles.icon} />
        <span>Live sessions</span>
        {openLiveSessions ? (
          <FaAngleDown className={styles.arrow} />
        ) : (
          <FaAngleRight className={styles.arrow} />
        )}
      </div>
      {openLiveSessions && (
        <div className={styles.subMenu}>
          <div
            className={
              isAllLiveSessionScreen
                ? styles.subMenuItemSelected
                : styles.subMenuItem
            }
            onClick={() => setIsAllLiveSessionScreen(true)}
          >
            All Sessions
          </div>
        </div>
      )}
    </div>
  );
};

export default TraderMenuPanel;
